var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormatAlignLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_881_2161",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_881_2161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 21.5V19.5H21V21.5H3ZM3 17.5V15.5H15V17.5H3ZM3 13.5V11.5H21V13.5H3ZM3 9.5V7.5H15V9.5H3ZM3 5.5V3.5H21V5.5H3Z",
    fill: "#505050"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormatAlignLeft);
export default __webpack_public_path__ + "static/media/format_align_left.f829c3ae018170d3288f47ce34cddb50.svg";
export { ForwardRef as ReactComponent };